import { graphQlClient } from '@config/graphqlClient';
import TaskTemplateGraphQL from '@graphql/taskTemplate.queries';
import {
  TaskTemplate,
  TaskTemplateCreateInput,
  TaskTemplateImportInput,
  GetTaskTemplatesRequest,
  GetTaskTemplateRequest,
  CreateTaskTemplateRequest,
  DeleteTaskTemplateRequest,
  ImportTaskTemplateRequest,
} from '@models/taskTemplate.model';

export const getTaskTemplates = async (): Promise<TaskTemplate[]> => {
  const data: GetTaskTemplatesRequest = await graphQlClient.request(
    TaskTemplateGraphQL.queries.getTaskTemplates,
  );
  return data.getTaskTemplates || [];
};

export const getTaskTemplate = async (templateId: string): Promise<TaskTemplate> => {
  const data: GetTaskTemplateRequest = await graphQlClient.request(
    TaskTemplateGraphQL.queries.getTaskTemplate,
    { templateId },
  );
  return data.getTaskTemplate;
};

export const createTaskTemplate = async (
  input: TaskTemplateCreateInput,
): Promise<TaskTemplate> => {
  const data: CreateTaskTemplateRequest = await graphQlClient.request(
    TaskTemplateGraphQL.mutations.createTaskTemplate,
    { input },
  );
  return data.createTaskTemplate;
};

export const deleteTaskTemplate = async (templateId: string): Promise<boolean> => {
  const data: DeleteTaskTemplateRequest = await graphQlClient.request(
    TaskTemplateGraphQL.mutations.deleteTaskTemplate,
    { templateId },
  );
  return data.deleteTaskTemplate;
};

export const importTaskTemplate = async (
  input: TaskTemplateImportInput,
): Promise<ImportTaskTemplateRequest['importTaskTemplate']> => {
  const data: ImportTaskTemplateRequest = await graphQlClient.request(
    TaskTemplateGraphQL.mutations.importTaskTemplate,
    { input },
  );
  return data.importTaskTemplate;
};

const taskTemplateService = {
  getTaskTemplates,
  getTaskTemplate,
  createTaskTemplate,
  deleteTaskTemplate,
  importTaskTemplate,
};

export default taskTemplateService;
